// highlight.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  transform(text: string, search: string): any {
    if (!search) return text;
    const pattern = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    const regex = new RegExp(pattern, 'gi');
    return text.replace(regex, match => `<span class="search-term bg-warning text-white">${match}</span>`);
  }
}
